export { default } from './text-max-line';

export { default as useTypography } from './use-typography';
